"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPopover = exports.PopoverContext = void 0;
var hooks_1 = require("@nef/hooks");
var react_1 = __importDefault(require("react"));
var resize_observer_1 = require("@juggle/resize-observer");
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Portal_1 = __importDefault(require("../Portal"));
var PopoverBody_1 = __importDefault(require("../PopoverBody"));
exports.PopoverContext = react_1.default.createContext({
    rtl: false
});
exports.StyledPopover = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  /* Styles brought over from Bootstrap */\n  position: ", ";\n  z-index: 1060;\n  display: block;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  opacity: 0;\n  text-align: left;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: ", ";\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  ", ";\n  height: ", ";\n  max-height: 30vh;\n  border-radius: ", ";\n  border: none !important;\n\n  ", "\n\n  ", ";\n\n  ", ";\n\n  ", "\n\n  @keyframes popIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"], ["\n  /* Styles brought over from Bootstrap */\n  position: ", ";\n  z-index: 1060;\n  display: block;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  opacity: 0;\n  text-align: left;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: ", ";\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  ",
    ";\n  height: ",
    ";\n  max-height: 30vh;\n  border-radius: ", ";\n  border: none !important;\n\n  ",
    "\n\n  ", ";\n\n  ",
    ";\n\n  ",
    "\n\n  @keyframes popIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"])), function (props) { return (props.fixed ? "fixed" : "absolute"); }, style_utils_1.getFont("heading"), style_utils_1.getColor("gray", 0), function (props) {
    return props.maxContent
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          width: max-content;\n          max-width: 100vw;\n        "], ["\n          width: max-content;\n          max-width: 100vw;\n        "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          max-width: ", ";\n          width: ", ";\n        "], ["\n          max-width: ", ";\n          width: ", ";\n        "])), props.width ? props.width + "px" : undefined, props.width ? props.width + "px" : undefined);
}, function (props) {
    return props.height ? style_utils_1.escapeCss(props.height + "px") : undefined;
}, style_utils_1.getBorderRadius("md"), function (props) {
    return props.rtl && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      direction: rtl;\n      text-align: right;\n    "], ["\n      direction: rtl;\n      text-align: right;\n    "])));
}, function (props) { return style_utils_1.setBoxShadow(style_utils_1.shadowSelector(props, 4)); }, function (props) {
    return props.isAnimated
        ? styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          -webkit-animation: popIn 166ms ease-in-out 83ms forwards;\n          animation: popIn 166ms ease-in-out 83ms forwards;\n        "], ["\n          -webkit-animation: popIn 166ms ease-in-out 83ms forwards;\n          animation: popIn 166ms ease-in-out 83ms forwards;\n        "]))) : styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          animation: popIn 0ms ease-in-out 83ms forwards;\n        "], ["\n          animation: popIn 0ms ease-in-out 83ms forwards;\n        "])));
}, function (props) {
    return !props.tooltip && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      overflow: auto !important;\n      overflow: overlay !important;\n      ", ";\n      span.arrow {\n        display: none;\n      }\n    "], ["\n      overflow: auto !important;\n      overflow: overlay !important;\n      ", ";\n      span.arrow {\n        display: none;\n      }\n    "])), style_utils_1.setPadding("y", 2));
});
var Popover = react_1.default.forwardRef(function (_a, ref) {
    var body = _a.body, children = _a.children, closeOnScroll = _a.closeOnScroll, fixed = _a.fixed, containInParent = _a.containInParent, height = _a.height, containerRef = _a.containerRef, innerRef = _a.innerRef, isOpen = _a.isOpen, maxContent = _a.maxContent, offsetBottom = _a.offsetBottom, offsetLeft = _a.offsetLeft, offsetRight = _a.offsetRight, offsetTop = _a.offsetTop, propOnKeyDown = _a.onKeyDown, onPlacementForceChange = _a.onPlacementForceChange, oppositeOnOverflow = _a.oppositeOnOverflow, placement = _a.placement, rtl = _a.rtl, target = _a.target, propToggle = _a.toggle, trigger = _a.trigger, style = _a.style, width = _a.width, props = __rest(_a, ["body", "children", "closeOnScroll", "fixed", "containInParent", "height", "containerRef", "innerRef", "isOpen", "maxContent", "offsetBottom", "offsetLeft", "offsetRight", "offsetTop", "onKeyDown", "onPlacementForceChange", "oppositeOnOverflow", "placement", "rtl", "target", "toggle", "trigger", "style", "width"]);
    var themeRtl = react_1.default.useContext(styled_components_1.ThemeContext).rtl;
    var popoverRef = react_1.default.useRef();
    var mutationObserver = react_1.default.useRef();
    var resizeObserver = react_1.default.useRef();
    var _b = __read(react_1.default.useState(placement), 2), placementVar = _b[0], setPlacementVar = _b[1];
    var _c = __read(react_1.default.useState({
        left: 0,
        top: 0,
        width: 0
    }), 2), placementVars = _c[0], setPlacementVars = _c[1];
    var getPlacementValues = react_1.default.useCallback(function (argPlacement, _a, _b) {
        var elBottom = _a.elBottom, elLeft = _a.elLeft, elTop = _a.elTop, elRight = _a.elRight;
        var elHeight = _b.elHeight, elWidth = _b.elWidth;
        var pageLeftOffset = 0;
        var pageTopOffset = 0;
        if (typeof document !== "undefined" && typeof window !== "undefined") {
            pageLeftOffset = fixed
                ? 0
                : window.pageXOffset || document.documentElement.scrollLeft;
            pageTopOffset = fixed
                ? 0
                : window.pageYOffset || document.documentElement.scrollTop;
        }
        var genericOffset = 3;
        var wrapperTopOffset = 0;
        var wrapperLeftOffset = 0;
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && !fixed) {
            var _c = containerRef.current.getBoundingClientRect(), parentLeft = _c.left, parentTop = _c.top;
            wrapperLeftOffset += parentLeft;
            wrapperTopOffset += parentTop;
        }
        var top = elTop + pageTopOffset + offsetTop - wrapperTopOffset;
        var bottom = elBottom + offsetBottom;
        var left = elLeft + pageLeftOffset + offsetLeft - wrapperLeftOffset;
        var right = elRight + offsetRight;
        switch (argPlacement) {
            case "bottom":
                return {
                    left: left + (right - elWidth) / 2,
                    top: top + bottom + genericOffset
                };
            case "bottom-start":
                return {
                    left: left,
                    top: top + bottom + genericOffset
                };
            case "bottom-end":
                return {
                    left: left + right - elWidth,
                    top: top + bottom + genericOffset
                };
            case "top":
                return {
                    left: left + (right - elWidth) / 2,
                    top: top - elHeight - genericOffset
                };
            case "top-start":
                return {
                    left: left,
                    top: top - elHeight - genericOffset
                };
            case "top-end":
                return {
                    left: left + right - elWidth,
                    top: top - elHeight - genericOffset
                };
            case "right":
                return {
                    left: left + right + genericOffset,
                    top: top + (bottom - elHeight) / 2
                };
            case "right-start":
                return {
                    left: left + right + genericOffset,
                    top: top
                };
            case "right-end":
                return {
                    left: left + right + genericOffset,
                    top: top + bottom - elHeight
                };
            case "left":
                return {
                    left: left - elWidth - genericOffset,
                    top: top + (bottom - elHeight) / 2
                };
            case "left-start":
                return {
                    left: left - elWidth - genericOffset,
                    top: top
                };
            case "left-end":
                return {
                    left: left - elWidth - genericOffset,
                    top: top + bottom - elHeight
                };
            default:
                return {
                    left: left + right - elWidth / 2,
                    top: top - elHeight - genericOffset
                };
        }
    }, [fixed, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);
    var setPlacement = react_1.default.useCallback(function (node) {
        var _a;
        var element = document.getElementById(target);
        var _b = (element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) || {
            height: 0,
            left: 0,
            right: 0,
            top: 0,
            width: 0
        }, targetHeight = _b.height, targetLeft = _b.left, targetRight = _b.right, targetBottom = _b.bottom, targetTop = _b.top, targetWidth = _b.width;
        var _c = (node === null || node === void 0 ? void 0 : node.getBoundingClientRect()) ||
            ((_a = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
            height: height,
            width: width
        }, elHeight = _c.height, elWidth = _c.width;
        var placementValues = getPlacementValues(placement, {
            elBottom: targetHeight,
            elLeft: targetLeft,
            elTop: targetTop,
            elRight: targetWidth
        }, { elHeight: elHeight, elWidth: elWidth });
        if (oppositeOnOverflow) {
            var newPlacement = placement;
            if (placementValues.top < window.pageYOffset &&
                window.innerHeight - targetBottom > elHeight &&
                newPlacement.includes("top")) {
                newPlacement = newPlacement.replace("top", "bottom");
            }
            if (placementValues.top + elHeight >
                window.innerHeight + window.pageYOffset &&
                targetTop > elHeight &&
                newPlacement.includes("bottom")) {
                newPlacement = newPlacement.replace("bottom", "top");
            }
            if (placementValues.left < window.pageXOffset &&
                window.innerWidth - targetRight > elWidth &&
                newPlacement.includes("left")) {
                newPlacement = newPlacement.replace("left", "right");
            }
            if (placementValues.left + elWidth >
                window.innerWidth + window.pageXOffset &&
                targetLeft > elWidth &&
                newPlacement.includes("right")) {
                newPlacement = newPlacement.replace("right", "left");
            }
            if (newPlacement !== placement) {
                setPlacementVar(newPlacement);
            }
            placementValues = getPlacementValues(newPlacement, {
                elBottom: targetHeight,
                elLeft: targetLeft,
                elTop: targetTop,
                elRight: targetWidth
            }, { elHeight: elHeight, elWidth: elWidth });
        }
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && containInParent) {
            var _d = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.getBoundingClientRect(), containerHeight = _d.height, containerWidth = _d.width;
            if (placementValues.top + elHeight > containerHeight) {
                placementValues.top = containerHeight - elHeight - 1;
            }
            if (placementValues.left + elWidth > containerWidth) {
                placementValues.left = containerWidth - elWidth - 1;
            }
        }
        if (placementValues.left < window.pageXOffset &&
            placementValues.left - elWidth + targetLeft < window.pageXOffset) {
            placementValues.left = window.pageXOffset;
        }
        else if (placementValues.left + elWidth >
            window.innerWidth + window.pageXOffset) {
            placementValues.left =
                window.innerWidth + window.pageXOffset - elWidth;
        }
        if (placementValues.top < window.pageYOffset &&
            placementValues.top - elHeight + targetTop < window.pageYOffset) {
            placementValues.top = window.pageYOffset;
        }
        else if (placementValues.top + elHeight >
            window.innerHeight + window.pageYOffset) {
            placementValues.top =
                window.innerHeight + window.pageYOffset - elHeight;
        }
        return placementValues;
    }, [placement, target, oppositeOnOverflow, height, width]);
    var toggle = function (e) {
        if (propToggle) {
            propToggle(e);
        }
    };
    react_1.default.useEffect(function () {
        var element;
        if (typeof document !== "undefined") {
            element = document.getElementById(target);
        }
        if (element) {
            if (trigger) {
                switch (trigger) {
                    case "click":
                        element.addEventListener("click", toggle);
                        break;
                    case "focus":
                        element.addEventListener("blur", toggle, true);
                        element.addEventListener("focus", toggle, true);
                        break;
                    case "hover":
                        element.addEventListener("mouseenter", toggle);
                        element.addEventListener("mouseleave", toggle);
                        break;
                    default:
                        break;
                }
            }
            setPlacementVars(__assign(__assign({}, setPlacement()), { width: element.getBoundingClientRect().width }));
        }
        return function () {
            if (element && trigger) {
                switch (trigger) {
                    case "click":
                        element.removeEventListener("click", toggle);
                        break;
                    case "focus":
                        element.removeEventListener("blur", toggle, true);
                        element.removeEventListener("focus", toggle, true);
                        break;
                    case "hover":
                        element.removeEventListener("mouseenter", toggle);
                        element.removeEventListener("mouseleave", toggle);
                        break;
                    default:
                        break;
                }
            }
        };
    }, [isOpen, target, trigger, setPlacement]);
    react_1.default.useEffect(function () {
        var handleScroll = function (e) {
            if (closeOnScroll &&
                (popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) &&
                !(popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current.contains(e.target))) {
                toggle(e);
            }
            else {
                setPlacementVars(function (prevState) { return (__assign(__assign({}, setPlacement()), { width: prevState.width })); });
            }
        };
        if (!(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || fixed || closeOnScroll) {
            window.addEventListener("scroll", handleScroll, true);
            return function () {
                window.removeEventListener("scroll", handleScroll, true);
            };
        }
        return undefined;
    }, [
        popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current,
        setPlacement,
        closeOnScroll,
        fixed,
        containerRef === null || containerRef === void 0 ? void 0 : containerRef.current
    ]);
    react_1.default.useEffect(function () {
        var element;
        if (typeof document !== "undefined") {
            element = document.getElementById(target);
        }
        if (element) {
            resizeObserver.current = new resize_observer_1.ResizeObserver(function (entries) {
                window.requestAnimationFrame(function () {
                    entries.forEach(function (entry) {
                        if (entry.target && isOpen) {
                            setPlacementVars(function (prevState) { return (__assign(__assign({}, setPlacement()), { width: entry.target === element
                                    ? entry.borderBoxSize[0].inlineSize
                                    : prevState.width })); });
                        }
                    });
                });
            });
            resizeObserver.current.observe(element);
            resizeObserver.current.observe(document.body);
        }
        mutationObserver.current = new MutationObserver(function (entries) {
            window.requestAnimationFrame(function () {
                entries.forEach(function (entry) {
                    if (entry.target) {
                        setPlacementVars(function (prevState) { return (__assign(__assign({}, setPlacement()), { width: prevState.width })); });
                    }
                });
            });
        });
        if (popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) {
            mutationObserver.current.observe(popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return function () {
            if (resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.current) {
                resizeObserver.current.disconnect();
            }
            if (mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.current) {
                mutationObserver.current.disconnect();
            }
        };
    }, [target, isOpen, maxContent, popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current, setPlacement]);
    react_1.default.useEffect(function () {
        onPlacementForceChange === null || onPlacementForceChange === void 0 ? void 0 : onPlacementForceChange(placementVar);
    }, [placementVar, onPlacementForceChange]);
    var callbackRef = react_1.default.useCallback(function (node) {
        if (node && !(popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current)) {
            setPlacementVars(function (prevState) { return (__assign(__assign({}, prevState), setPlacement(node))); });
        }
    }, [placement, popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current, setPlacement]);
    var combinedRef = hooks_1.useCombinedRefs(callbackRef, popoverRef, innerRef, ref);
    var handleKeyDown = function (e) {
        var _a;
        propOnKeyDown === null || propOnKeyDown === void 0 ? void 0 : propOnKeyDown(e);
        if (hooks_1.navigationKeys.includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (e.key === "Escape" || e.key === "Esc") {
            (_a = document.getElementById(target)) === null || _a === void 0 ? void 0 : _a.focus();
            toggle(e);
        }
    };
    var onKeyDown = hooks_1.useKeyDown({
        ref: combinedRef,
        onKeyDown: handleKeyDown
    }).onKeyDown;
    return (react_1.default.createElement(Portal_1.default, { node: containerRef && containerRef.current },
        react_1.default.createElement(exports.PopoverContext.Provider, { value: { rtl: themeRtl || rtl } }, isOpen && (react_1.default.createElement(exports.StyledPopover, __assign({}, props, { fixed: fixed, maxContent: maxContent, ref: combinedRef, height: height, width: width || placementVars.width, rtl: rtl, style: __assign(__assign({}, style), { left: (style === null || style === void 0 ? void 0 : style.left) || placementVars.left + "px", top: (style === null || style === void 0 ? void 0 : style.top) || placementVars.top + "px" }), onKeyDown: onKeyDown }),
            body && react_1.default.createElement(PopoverBody_1.default, null, body),
            children)))));
});
Popover.displayName = "Popover";
Popover.defaultProps = {
    fixed: false,
    as: "div",
    offsetBottom: 0,
    offsetLeft: 0,
    offsetRight: 0,
    offsetTop: 0,
    placement: "bottom",
    width: 0,
    isAnimated: true
};
exports.default = Popover;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=index.js.map